import React from 'react'
import MaskedInput from 'react-maskedinput'
import './index.css'

function DateInput(props) {
    return <MaskedInput mask="11/11/1111" placeholder='' className={props.className} onChange={props.onChange} value={props.value}/>;
}

export default (DateInput);